import { Injectable } from '@angular/core';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';
import { FormDataService } from '../trainer/trainers-form.data.service';
import { alumniForm, AlumniModel } from 'common/models/page-models/Alumni-form/alumni-form-data-model';

@Injectable({
  providedIn: 'root',
})
export class AlumniFormDataService extends FormDataService<AlumniModel> {
  constructor(http: SmApiService, ss: SystemService) {
    super(API_URL.editAlumniStudent, http, ss);
  }


  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.alumniStudent,
      method: API_METHODS.post,
    };
    return edit;
  }

  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();
    dataModel.first_name = response.details.student_detail.first_name;
    dataModel.last_name = response.details.student_detail.last_name;
    dataModel.mobile_number = response.details.student_detail.mobile_number;
    dataModel.email = response.details.student_detail.email;
    dataModel.name_of_college = response.details.student_detail.name_of_college;
    dataModel.college_address = response.details.student_detail.college_address;
    dataModel.branch_id = response.details.student_detail.branch_name;
    dataModel.placement_company_name = response.details.student_detail.placement_company_name;
    dataModel.placement_company_location = response.details.student_detail.placement_company_location;
    dataModel.placement_company_designation = response.details.student_detail.placement_company_designation;
    dataModel.gender = (response.details.student_detail.gender);
    dataModel.other = response.details.student_detail.other;
    dataModel.profile_pic_path = response.details.student_detail.profile_pic_path;



    return dataModel;

  }


  uppercaseFirstLetter(str: string) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  }

  firstCaseLower(str: string): string {
    if (!str) return str;
    return str[0].toLowerCase() + str.slice(1).toLowerCase();
  }



  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<AlumniModel> {
    return new Promise<any>((resolve, reject) => {
      const submitData: any = new alumniForm();
      submitData.first_name = model.first_name;
      submitData.last_name = model.last_name;
      submitData.mobile_number = model.mobile_number;
      submitData.email = model.email;
      submitData.gender = model.gender;
      submitData.other = model.other;
      submitData.name_of_college = model.name_of_college;
      submitData.college_address = model.college_address;
  
      if ((model.profile_pic_path instanceof File)) {
        submitData.profile_pic_path = model.profile_pic_path;
      }
  
      submitData.placement_company_name = model.placement_company_name;
      submitData.placement_company_location = model.placement_company_location;
      submitData.placement_company_designation = model.placement_company_designation;
  
      resolve(this.convertFormData(submitData));
    });
  }
  


  postLoginData(data, url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService
        .postData(url, this.convertFormData(data))
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

    override afterPostData(
      model: AlumniModel,
      response
    ): Promise<AlumniModel> {
      return new Promise<AlumniModel>((resolve, reject) => {
        const currentProfile = this.systemService.getProfile();
        if (response.status === 'Success' && currentProfile.role === 2 && currentProfile.status === 2) {
          currentProfile.isProfileUpdateFlag = 1;
          this.ss.setlocalStorage('loginData', JSON.stringify(currentProfile));
        }
        resolve(this.transformAPIData(model));
      }).catch((err) => {
        throw err;
      });
    }
  

  createInstance(): AlumniModel {
    return new AlumniModel();
  }
}

export { FormDataService };

